<template>
  <div
    class="appo"
    @dblclick.prevent
  >
    <div class="appo__header">
      <!-- <base-heading class="mb-0">
        {{ appointment.subject }}
        <base-icon icon="add-link" />
      </base-heading> -->
      <!--eslint-disable-next-line-->
      <template v-if="logo">
        <div class="appo__logo__container">
          <img
            class="appo__logo"
            :src="`${logo}?h=100&fit=clip`"
            alt=""
          >
        </div>
      </template>
    </div>
    <div class="appo__main">
      <div class="appo__container">
        <div class="appo__left">
          <div
            id="local--"
            ref="local"
            class="appo__video"
          >
            <div
              v-show="streamStatus === 'active' && streamerIsOn"
              class="appo__video__container"
              :style="videoExtraStyles"
            >
              <video
                v-show="!appointment.is_host"
                id="mux-default"
                class="video-js vjs-16-9"
                poster="@/assets/black-screen.png"
                preload="auto"
              />
              <div
                v-if="paused && !appointment.is_host"
                class="play_button"
                @click="togglePlay"
              >
                <base-icon icon="play-button" />
              </div>
              <div
                v-if="appointment.is_host"
                class="video-main"
              >
                <video
                  ref="mainVideo"
                  class="video-main-video"
                  autoplay
                  muted
                  playsinline
                />
              </div>
            </div>
            <div
              v-show="streamStatus !== 'active' || !streamerIsOn"
              class="appo__video__not_here"
            >
              <offline-screen
                :title="appointment.title"
                :intro="!streamConnectedOnce"
                :contact="appointment.stylist_email"
                :institution-pk="'' + appointment.inst_pk"
                :fonts="appointment.fonts"
              />
            </div>
            <div
              v-if="(blurCorner || showConnectedList) && appointment.is_host"
              class="appo__overlay"
            />
            <div class="appo__floating-actions">
              <base-button
                v-if="!connected && appointment.is_host"
                class="appo__connect-button"
                @click="videoconnect"
              >
                Connect
              </base-button>
              <!-- Button dicconnect for Mobile -->
              <base-button
                v-if="connected && appointment.is_host"
                class="appo__call-button"
                nowrap
                accent
                @click="disconnect"
              >
                End
              </base-button>

              <participant-count
                v-if="streamerIsOn && streamConnectedOnce"
                :connected="connected"
                :appointment="appointment"
                :participants="participants"
                :stream-status="streamStatus"
                small
                @set-blur-corner="setBlurCorner"
              />
              <div class="appo__handle_scroll">
                <div
                  v-if="showConnectedList && appointment.is_host"
                  class="
                    appo__participants_overflow
                    appo__participants_overflow--small
                  "
                >
                  <div
                    v-for="part in participants"
                    :key="part.sid"
                    class="appo__participants-show-text"
                  >
                    <p class="participant_identity">
                      {{ part.name.replace(/\[.*\]/, "").trim() }}
                    </p>
                  </div>
                </div>
              </div>
              <!-- <div
                v-if="connected === true"
                class="appo__actions-button"
                @click="showMenuMobile = !showMenuMobile"
              >
                <base-icon icon="ellipsis-h" />
              </div>
              <div
                v-if="showMenuMobile === true"
                class="appo__actions-button-box"
              >
                <template v-for="action in actions">
                  <div
                    v-if="(appointment.is_host && action.hostOnly) || !action.hostOnly"
                    :key="action.text"
                    class="appo__action"
                    @click="
                      action.action();
                      showMenuMobile = false;
                    "
                  >
                    <base-icon
                      width="24px"
                      :icon="action.active() ? action.icon : action.activeIcon"
                    />
                    {{ action.active() ? action.text : action.activeText }}
                  </div>
                </template>
              </div> -->
            </div>
            <div
              v-if="streamerIsOn && streamConnectedOnce"
              class="appo__chat__small"
            >
              <chat-container
                :is-open="chatOpened"
                :is-mobile="true"
                :appointment-id="appointment.pk"
                :username="username"
              />
              <div class="appo__chat__small__icon">
                <base-icon
                  style="position: relative; z-index: 103; width: 29px"
                  icon="open-chat-white"
                  @click="openChat"
                />
              </div>
            </div>
            <participant-count
              v-if="streamerIsOn && streamConnectedOnce"
              :connected="connected"
              :appointment="appointment"
              :participants="participants"
              :stream-status="streamStatus"
              @set-blur-corner="setBlurCorner"
            />
            <video-product-detail-container
              v-if="
                connected === true && itemSelected !== null && itemSelected.pk
              "
              ref="pinned"
              :actions-allowed="appointment.is_host"
              :product-id="itemSelected.pk"
              :offset="itemSelectedCarouselOffset"
              :thumbnail-url="thumbnailUrl"
              @close="closeProduct()"
              @scroll="handleScroll"
            />
            <div
              v-if="false"
              class="appo__pinned-item"
            >
              <div class="appo__pinned-item__container">
                <img
                  class="appo__pinned-item__img"
                  :src="product_url"
                >
                <base-icon
                  v-if="appointment.is_host"
                  icon="cancel"
                  class="appo__pinned-item__button"
                  @click="product_url = ''"
                />
              </div>
            </div>
          </div>
          <div class="appo__controls">
            <template v-if="connected && streamerIsOn && streamConnectedOnce">
              <chat-container
                v-show="chatOpened"
                :appointment-id="appointment.pk"
                :username="username"
              />

              <template v-for="action in actions">
                <span
                  v-if="
                    (appointment.is_host && action.hostOnly) || !action.hostOnly
                  "
                  :key="action.name"
                  class="appo__action"
                  @click="action.action()"
                >
                  <template v-if="action.icon === 'no-chat'">
                    <div class="appo__action__wrapper">
                      <chat-notification :number="unreadCount">
                        <base-icon
                          class="action-icon"
                          :icon="
                            action.active() ? action.icon : action.activeIcon
                          "
                        />
                      </chat-notification>
                      <div>
                        {{ action.active() ? action.text : action.activeText }}
                      </div>
                    </div>
                  </template>

                  <template v-else-if="action.icon === 'appointment-link'">
                    <base-tooltip :text="inviteLinkText">
                      <div class="appo__action__wrapper">
                        <base-icon
                          class="action-icon"
                          :icon="
                            action.active() ? action.icon : action.activeIcon
                          "
                        />
                        {{ action.active() ? action.text : action.activeText }}
                      </div>
                    </base-tooltip>
                  </template>

                  <template v-else>
                    <div class="appo__action__wrapper">
                      <base-icon
                        class="action-icon"
                        :icon="
                          action.active() ? action.icon : action.activeIcon
                        "
                      />
                      {{ action.active() ? action.text : action.activeText }}
                    </div>
                  </template>
                </span>
              </template>
            </template>
            <div class="ml-auto">
              <base-button
                v-if="streamIsDisabled && appointment.is_host"
                @click="videoconnect"
              >
                Connect
              </base-button>
              <base-button
                v-if="!streamIsDisabled && appointment.is_host"
                nowrap
                accent
                @click="disconnect"
              >
                End Appointment
              </base-button>
            </div>
          </div>
        </div>
        <div
          v-if="connected"
          class="appo__right"
          :class="{
            'appo__right--half': showProducts === 1,
            'appo__right--open': showProducts === 2,
          }"
        >
          <div
            v-if="showProducts === 2"
            class="appo__close-products"
          >
            <!-- Close icon -->
            <base-icon
              icon="close-x"
              @click="openProducts()"
            />
          </div>
          <transition name="delayed-fade">
            <div
              v-if="showProducts === 0"
              class="appo__toggle-products"
              style="pointer-events: none"
            >
              <div style="pointer-events: all">
                <div class="appo__toggle-products__icon-up">
                  <base-icon
                    icon="angle-up"
                    @click="openProducts()"
                  />
                </div>
                <!-- Displays producs on mobile -->
                <base-button
                  style="height: 43px"
                  @click="openProducts()"
                >
                  {{ showProductsMessages[showProducts] }}
                </base-button>
              </div>
            </div>
          </transition>
          <div
            v-if="streamerIsOn && streamConnectedOnce"
            class="appo__right__scrollable"
            :class="{
              'appo__right__scrollable--horizontal': showProducts === 1,
            }"
          >
            <video-product
              v-for="(prodImage, index) in productImages"
              :key="index"
              v-multiclick
              :disabled="chatLoading"
              :product-image="prodImage"
              :active="itemSelected && itemSelected.pk === prodImage.product.pk"
              :can-like="!appointment.is_host"
              :favorite="likedProducts.includes(prodImage.product.pk)"
              @single-click="selectProduct(prodImage)"
              @like="like(prodImage.product)"
              @unlike="unlike(prodImage.product)"
            />
          </div>
        </div>
      </div>
    </div>
    <input
      ref="link"
      type="text"
      :value="inviteLink"
      style="opacity: 0"
    >
    <credentials-modal
      :show="modalOpen && appointment.is_host"
      :stream-key="streamKey"
      @close="modalOpen = false"
    />
    <select-camera-modal-container
      :show-camera-selector="showCameraSelector"
      @closed="showCameraSelector = false"
      @stream="connectVideoStream"
    />
  </div>
</template>

<script>
import videojs from '@mux/videojs-kit';
import '@mux/videojs-kit/dist/index.css';
import axios from 'axios';
import ChatNotification from '@/components/Chat/ChatNotification';
import { appointmentsService, eventsService } from '../../_services';
import VideoProduct from './VideoProduct';
import VideoProductDetailContainer from './VideoProductDetailContainer';
import CredentialsModal from './CredentialsModal';
import OfflineScreen from './OfflineScreen';
import ParticipantCount from '../../components/Widgets/Appointments/ParticipantCount';
import SelectCameraModalContainer from './SelectCameraModalContainer';

export default {
  name: 'MuxLiveStream',
  components: {
    OfflineScreen,
    VideoProduct,
    VideoProductDetailContainer,
    CredentialsModal,
    ChatNotification,
    ParticipantCount,
    SelectCameraModalContainer,
  },
  props: {
    appointment: {
      type: Object,
      default: null,
    },
    playback: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // inviteLinkText: 'Copy link',
      videoExtraStyles: {
        '--adjusted-object-fit': 'cover',
      },
      itemSelectedCarouselOffset: 0,
      showCameraSelector: false,
      stream: null,
      streamConnectedOnce: false,
      streamerIsOn: false,
      streamIsDisabled: false,
      lastSeekableEnd: 0,
      itemSelected: null,
      showProducts: 0,
      showProductsMessages: ['View Products', '', ''],
      tooltipText: 'Copy to Clipboard',
      streamKey: '',
      modalOpen: false,
      showConnectedList: false,
      blurCorner: false,
      participants: [],
      playerClient: null,
      streamStatus: 'idle',
      playerInitTime: Date.now(),
      connected: false,
      productImages: [],
      logo: '',
      inviteLink: null,
      showMenuMobile: false,
      inviteLinkText: 'Copy to clipboard',
      muted: true,
      paused: true,
      chatOpened: false,
      actions: [
        {
          active: () => this.chatOpened,
          text: 'Close Chat',
          activeText: 'Open Chat',
          icon: 'no-chat',
          activeIcon: 'open-chat',
          action: this.openChat,
          hostOnly: false,
        },
        {
          active: () => true,
          text: 'Copy Link',
          activeText: 'Copy Link',
          icon: 'appointment-link',
          activeIcon: 'appointment-link',
          action: this.copyLink,
          hostOnly: false,
        },
      ],
      pollInterval: null,
    };
  },
  computed: {
    chatLoading() {
      return this.$store.state.chat.loading;
    },
    formattedMessages() {
      return this.$store.getters['chat/formattedMessages'];
    },
    likedProducts() {
      return this.appointment.likes.map((like) => like.product__pk);
    },
    unreadCount() {
      if (this.$store.state.chat.unreadMessageCount && !this.chatOpened) {
        return this.$store.state.chat.unreadMessageCount;
      } else {
        return 0;
      }
    },
    username() {
      if (this.appointment.anon === null) {
        return `${this.appointment.name}[${this.appointment.invite_pk}]`;
      } else {
        return `${this.appointment.name}[${this.appointment.anon}]`;
      }
    },
  },
  watch: {
    stream(newval) {
      this.$refs.mainVideo.srcObject = null;
      this.$refs.mainVideo.srcObject = newval;
    },
    streamConnectedOnce(newval) {
      if (newval && this.appointment.is_host) {
        this.showCameraSelector = true;
      }
    },
    '$store.state.chat.messages': {
      handler() {
        if (this.chatOpened) {
          this.$store.dispatch('chat/setAllMessagesAsRead');
        } else {
          this.$store.dispatch('chat/getUnreadMessagesCount');
        }
      },
    },
    '$store.state.chat.task': {
      handler() {
        this.onHostMessage(this.$store.state.chat.task);
      },
    },
    streamStatus: {
      handler(newval) {
        if (newval === 'active') {
          this.playerClient.src({ type: 'video/mux', src: this.playback });
          this.autoPlay();
        } else {
          this.playerClient.src({ type: 'video/mux', src: '' });
        }
      },
    },
  },
  mounted() {
    axios
      .get(`${this.apiRoot()}${this.appointment.detail}video_data/`)
      .then((r) => {
        this.productImages = r.data.product_images;
        this.logo = r.data.institution.logo;
        this.inviteLink = r.data.invite_link;
      });
    this.joinChatRoom();
    this.createVideoPlayer();
    this.getLiveStreamStatus();
    this.setInitialValues();
    this.pollInterval = setInterval(this.getLiveStreamStatus, 5000);
    this.fetchStreamKey();
    this.connected = true;
    console.log(this.appointment);
  },
  methods: {
    connectVideoStream(stream) {
      this.stream = stream;
      this.showCameraSelector = false;
    },
    videoconnect() {
      appointmentsService
        .enableLiveStream(this.appointment.pk)
        .then((res) => {
          this.streamIsDisabled = false;
          this.connected = true;
        })
        .catch((e) => {
          this.streamIsDisabled = true;
          this.connected = false;
          console.log(e);
        });
    },
    disconnect() {
      appointmentsService
        .disableLiveStream(this.appointment.pk)
        .then((res) => {
          this.connected = false;
          this.streamIsDisabled = true;
        })
        .catch((e) => {
          this.streamIsDisabled = true;
          this.connected = false;
          console.log(e);
        });
    },
    joinChatRoom() {
      this.$store
        .dispatch('chat/joinChatRoom', {
          appointmentId: this.appointment.pk,
          username: this.username,
        })
        .then(() => {
          this.parseInitialSystemMessages();
        });
    },
    parseInitialSystemMessages() {
      let initialCarouselOfsset = 0;
      this.formattedMessages
        .filter((item) => item.attributes.type === 'system')
        .reverse()
        .some((systemMessage) => {
          const { action, payload } = systemMessage.attributes;
          if (action === 'scrollProduct') {
            if (payload.direction === 'right') {
              initialCarouselOfsset -= 1;
            } else {
              initialCarouselOfsset += 1;
            }
          } else if (action === 'selectProduct') {
            this.$nextTick().then(() => {
              this.onHostMessage({
                action,
                payload: {
                  ...payload,
                  offset: initialCarouselOfsset,
                },
              });
            });
            return true;
          } else if (action === 'deselectProduct') {
            return true;
          }
          return false;
        });
    },
    openProducts() {
      // Removed middle step - Now we have closed and open
      if (this.showProducts === 0) {
        this.showProducts = 2;
      } else {
        this.showProducts = 0;
      }
    },
    like(prod) {
      axios
        .post(`${this.apiRoot()}/productlike/`, {
          product: prod.pk,
          appointment: this.appointment.pk,
          _customer: this.appointment.invite_pk,
          _anonymous_participant: this.appointment.anon,
        })
        .then((r) => {
          this.appointment.likes.push({ product__pk: prod.pk, pk: r.data.pk });
          prod.like = r.data.pk;
        });
      this.sendMessage({
        action: 'likeProduct',
        payload: {
          product: prod,
        },
      });
    },
    unlike(prod) {
      const likePk = this.appointment.likes.find(
        (item) => item.product__pk === prod.pk,
      ).pk;
      axios
        .delete(`${this.apiRoot()}/productlike/${likePk}/`)
        .then(() => {
          this.appointment.likes = this.appointment.likes.filter(
            (item) => item.pk !== likePk,
          );
        })
        .catch(() => {
          console.error('Failed to unlike', likePk);
        });
      this.sendMessage({
        action: 'unlikeProduct',
        payload: {
          product: prod,
        },
      });
    },
    closeProduct() {
      this.itemSelected = null;
      this.thumbnailUrl = null;
      this.sendMessage({
        action: 'deselectProduct',
      });
    },
    handleScroll(direction) {
      this.sendMessage({
        action: 'scrollProduct',
        payload: { direction },
      });
    },
    selectProduct(prodImage) {
      const prod = prodImage.product;
      if (!this.appointment.is_host) {
        this.openInNewTab(prod.site_url);
        eventsService.saveClickEvent({ ...prod, inv_uuid: this.$route.params.id });
        return;
      }
      this.showProducts = 1;
      if (this.itemSelected && this.itemSelected.pk === prod.pk) {
        this.itemSelected = null;
        this.sendMessage({
          action: 'deselectProduct',
        });
      } else {
        this.itemSelected = prod;
        this.thumbnailUrl = prodImage.image_url;
        this.sendMessage({
          action: 'selectProduct',
          payload: { item: prod, thumbnailUrl: prodImage.image_url, offset: 0 },
        });
      }
    },
    sendMessage(message) {
      this.$store.dispatch('chat/sendMessage', {
        message: '[system command]',
        attributes: {
          type: 'system',
          action: message.action,
          payload: message.payload,
        },
      });
    },
    onHostMessage(message) {
      const { action, payload } = message;

      console.log('onHostMessage', message);

      if (action === 'selectProduct') {
        this.itemSelectedCarouselOffset = payload.offset;
        this.product_url = payload.url;
        this.itemSelected = payload.item;
        this.thumbnailUrl = payload.thumbnailUrl;
      }

      if (action === 'deselectProduct') {
        this.itemSelected = null;
        this.thumbnailUrl = null;
      }
      if (action === 'likeProduct') {
        console.log('Like');
      }
      if (action === 'scrollProduct') {
        const { pinned } = this.$refs;
        pinned.$refs.product.scroll(payload.direction);
      }
    },
    fetchStreamKey(id) {
      appointmentsService
        .fetchStreamKey(this.appointment.pk)
        .then((response) => {
          this.streamKey = response.data.stream_key;
        });
    },
    copyToClipboard(text) {
      this.tooltipText = 'Copied!';
      window.Clipboard.copy(text);
      setTimeout(() => {
        this.tooltipText = 'Copy to clipboard';
      }, 30000);
    },
    autoPlay() {
      this.playerClient
        .play()
        .then(() => {
          console.log('Autoplay success!');
          this.paused = false;
          this.playerClient.liveTracker.seekToLiveEdge();
        })
        .catch((error) => {
          this.paused = true;
          console.log('Autoplay error', error);
        });
    },
    togglePlay() {
      const paused = this.playerClient.paused();
      if (paused) {
        this.playerClient.play();
        this.playerClient.liveTracker.seekToLiveEdge();
        this.playerClient.muted(false);
        this.muted = false;
        this.paused = false;
      } else {
        this.playerClient.pause();
        this.paused = true;
      }
    },
    toggleMute() {
      const muted = this.playerClient.muted();
      if (muted) {
        this.playerClient.muted(false);
        this.muted = false;
      } else {
        this.playerClient.muted(true);
        this.muted = true;
      }
    },
    setBlurCorner(event) {
      this.blurCorner = event;
    },
    copyLink() {
      const copyText = this.$refs.link;
      copyText.select();
      copyText.setSelectionRange(0, 99999); /* For mobile devices */
      document.execCommand('copy');
      this.inviteLinkText = 'Copied!';
      setTimeout(() => {
        this.inviteLinkText = 'Copy to clipboard';
      }, 5000);
    },
    openChat() {
      this.chatOpened = !this.chatOpened;
      if (this.chatOpened) {
        this.$store.dispatch('chat/setAllMessagesAsRead');
      }
    },
    setInitialValues() {
      appointmentsService
        .fetchStreamStatus(this.appointment.pk, this.$route.params.id)
        .then((r) => {
          if (r.data.stream_status !== 'active') {
            this.modalOpen = true;
          }
          if (r.data.stream_status === 'disabled') {
            this.streamIsDisabled = true;
          } else {
            this.streamIsDisabled = false;
          }
        });
    },
    getLiveStreamStatus() {
      appointmentsService
        .fetchStreamStatus(this.appointment.pk, this.$route.params.id)
        .then((r) => {
          this.streamStatus = r.data.stream_status;
          this.participants = r.data.active_participants;
          this.productImages = r.data.product_images;
          if (this.playerClient.readyState() === 4) {
            const aspectRatio = this.playerClient.videoWidth() / this.playerClient.videoHeight();
            if (aspectRatio > 1) {
              this.videoExtraStyles['--adjusted-object-fit'] = 'cover';
            } else {
              this.videoExtraStyles['--adjusted-object-fit'] = 'scale-down';
            }
            this.streamConnectedOnce = true;
          }
        });
      const sEnd = this.playerClient.liveTracker.seekableEnd();
      /*
      The following if statement incorrectly identifies the stream as off
      when it is on, stoping the stream incorrectly

      if (sEnd === this.lastSeekableEnd) {
        this.streamerIsOn = false;
        console.log("STREAMER OFF");
      } else {
        this.streamerIsOn = true;
        console.log("STREAMER ON");
      }
      */
      this.lastSeekableEnd = sEnd;
    },
    createVideoPlayer() {
      this.playerClient = videojs('mux-default', {
        liveui: true,
        techOrder: ['html5'],
        playsinline: true,
        resizeManager: false,
        fluid: true,
        plugins: {
          mux: {
            data: {
              env_key: 'iojvgdca756c3r8mcfpmhibdd',
              video_title: this.appointment.title,
              viewer_user_id: this.appointment.name,
              sub_property_id: 'Seer',
            },
          },
        },
      });
      // eslint-disable-next-line
      this.playerClient.player_.handleTechClick_ = () => {};
      this.autoPlay();
      this.streamerIsOn = true;
      this.playerClient.on('ended', () => {
        this.getLiveStreamStatus();
        this.playerClient.reset();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
$breakpoint-1: 1024px;
// .chat-box {
//   display: block;
//   position: absolute;
//   left: 250px;
//   bottom: 40px;
//   z-index: 9999;
// }
.participant_identity {
  font-family: "SilkaRegular";
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.9);

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 96%;
  text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.5);
  margin: 0;
  margin-top: 8px;
}
.play_button {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  width: 120px;
  height: 120px;
  display: flex;
  justify-content: center;
}
.vjs-tech {
  object-fit: var(--adjusted-object-fit);
}

.vjs-16-9 {
  padding-top: 0;
}
.video-js {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.appo {
  // margin-top: -60px;
  padding-top: 50px;
  background: $black;
  // padding-bottom: 1rem;
  // min-height: 100vh;
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
  @media (min-width: $breakpoint-1) {
    padding-top: 60px;
  }
  &__header {
    display: flex;
    width: 100%;
    min-height: 70px;
    background: white;
    padding: 0.5rem 1rem;
    align-items: center;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    z-index: 999;
    box-shadow: 0 0 20px rgba(black, 0.1);
  }
  &__logo {
    // width: 180px;
    height: 50px;
    object-fit: cover;
    margin: 0 auto;
  }
  /**
  NOTE: I'm not happy with this! We need to refactor MUX and VideoCall to use
  the same component.
  @see VideoCall.vue
  */
  // With this we are centering the logo and aligning it to the video
  // @see https://helloseer.slack.com/archives/C015UMFDKRS/p1637561066012600
  &__logo__container{
    width: 100%;
    display: flex;
    justify-items: center;
    @media (min-width: map-get($breakpoints,'lg')) {
      margin-right: calc(250px + 1rem); // Right column width + padding
    }
  }
  &__main {
    top: 75px;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    position: absolute;
  }
  &__container {
    min-height: 100%;
    display: flex;
    margin: 0;
    @media (min-width: $breakpoint-1) {
      border-radius: 5px;
      background: white;
      // min-height: calc(100vh - 150px);
    }
  }
  &__left {
    flex-grow: 2;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    max-width: 100%;
    @media (min-width: $breakpoint-1) {
      padding: 1rem;
      padding-right: 0;
      margin-right: 1rem;
    }
  }
  &__right {
    background-color: white;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    max-height: 10px;
    top: 100%;
    // bottom: 0;
    z-index: 101;
    transition: all 0.2s ease-out;
    box-shadow: 0 0 40px rgba(black, 0.2);

    &--half {
      top: calc(100% - 290px);
      max-height: 100vh;
    }

    &--open {
      top: 30px;
      max-height: 100vh;
      transition: all 0.3s cubic-bezier(0.175, 0.885, 0.335, 1.15);
      @media (min-width: $breakpoint-1) {
        top: 0;
      }
    }

    @media (min-width: $breakpoint-1) {
      background-color: transparent;
      width: 250px;
      bottom: 0;
      position: relative;
      max-height: inherit;
      box-shadow: none;
    }
  }
  &__close-products {
    position: absolute;
    left: 24px;
    top: 24px;
  }
  &__right__scrollable {
    position: absolute;
    left: 1rem;
    right: 1rem;
    top: 4rem;
    bottom: 0;
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    justify-content: center;

    &--horizontal {
      flex-wrap: nowrap;
      & > * {
        margin-right: 1rem;
      }
      @media (min-width: $breakpoint-1) {
        // flex-direction: column;
        flex-wrap: wrap;
        & > * {
          margin-right: 0;
        }
      }
    }
    @media (min-width: $breakpoint-1) {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      padding-top: 14px;
    }
  }
  &__toggle-products {
    // background-color: white;
    // border-radius: 5px 5px 0 0;
    top: -92px;
    // width: 180px;
    height: 92px;
    position: relative;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.5rem;
    cursor: pointer;
    &__icon {
      margin-left: 10px;
    }
    &__icon-up {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      min-height: 24px;
    }
    @media (min-width: $breakpoint-1) {
      display: none;
    }
  }

  &__chat__small {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 1rem;
    min-height: 92px;
    background: rgba(black, 1);
    z-index: 101;
    @media (min-width: $breakpoint-1) {
      display: none;
    }
    &::v-deep .chat {
      bottom: 60px;
    }

    &__icon {
      position: absolute;
      right: 24px;
      bottom: calc(50% - 20px);
      // width: calc(50% - 120px);
      text-align: center;
    }
  }
  &__video {
    // background: gray;
    line-height: 0;
    height: 100%;
    display: flex;
    position: relative;
  }

  &__video__not_here {
    height: 100%;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    // background-color: red;
    background-color: white;
    color: $black;
    border: 1px solid $black;
    width: 100%;
  }
  &__video__container {
    height: 100%;
    display: flex;
    align-items: center;
    width: 100%;
    overflow: hidden;
    position: relative;
    background-color: $black;
  }
  &__participants {
    position: absolute;
    left: 0rem;
    top: 1rem;
    display: none;
    @media (min-width: 420px) {
      display: flex;
    }
    @media (min-width: $breakpoint-1) {
      left: inherit;
      top: inherit;
      right: 1rem;
      bottom: 1rem;
    }

    &::v-deep video {
      width: 110px !important;
      height: 230px;
      border-radius: 15px;
      overflow: hidden;
      margin-left: 1rem;
      object-fit: cover;
      @media (min-width: $breakpoint-1) {
        width: 240px !important;
        height: 160px;
      }
    }

    &--screen-shared {
      flex-flow: column;
      &::v-deep video {
        width: 180px !important;
        height: 108px;
        border-radius: 0;
      }
    }
  }
  &__participants-show {
    padding-top: 5px;
    padding-left: 12px;
    padding-right: 4px;
    background: transparent;
    border-radius: 8px;
    right: 0rem;
    top: 1rem;
    position: absolute;
    width: 220px;
    height: 260px;
    mask-image: linear-gradient(to bottom, black 60%, transparent 100%);

    ::-webkit-scrollbar {
      width: 4px;
      border-radius: 100px;
    }

    /* Track */
    // ::-webkit-scrollbar-track {
    // }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #faf9f7;
      border-radius: 100px;
      height: 20px;
    }
  }
  &__handle_scroll {
    mask-image: linear-gradient(to bottom, black 60%, transparent 100%);
    padding-left: 0px;
    padding-top: 0px;
    padding-right: 0px;
    background: transparent;
    border-radius: 8px;
    top: 2.5rem;
    right: 0rem;
    position: absolute;
    width: 170px;
    height: 220px;
    ::-webkit-scrollbar {
      width: 4px;
      border-radius: 100px;
    }

    /* Track */
    // ::-webkit-scrollbar-track {
    // }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #faf9f7;
      border-radius: 100px;
      height: 20px;
    }
  }
  &__participants_overflow {
    height: 186px;
    max-width: 100%;
    text-align: left;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    padding-top: 0px;
  }
  &__participants-show-text {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
  }
  &__floating-actions {
    right: 1rem;
    left: 1rem;
    top: 1rem;
    position: absolute;
    display: flex;
    justify-content: flex-end;
    @media (min-width: $breakpoint-1) {
      display: none;
    }
  }
  &__overlay {
    @keyframes scale {
      0% {
        transform-origin: 0% 0%;
        opacity: 0;
      }
      30% {
        opacity: 0.3;
        transform-origin: 25% 25%;
      }
      50% {
        opacity: 0.5;
        transform-origin: 75% 75%;
      }
      80% {
        opacity: 0.8;
        transform-origin: 100% 100%;
      }
      100% {
        opacity: 1;
      }
    }
    width: 100%;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    background: linear-gradient(
        269.93deg,
        #ffffff 63.58%,
        rgba(255, 255, 255, 0) 99.94%
      ),
      linear-gradient(180deg, #ffffff 51.37%, rgba(255, 255, 255, 0) 63.19%),
      linear-gradient(
        270.08deg,
        rgba(0, 0, 0, 0.85) 47.61%,
        rgba(0, 0, 0, 0.42) 57.61%,
        rgba(0, 0, 0, 0.14) 65.87%,
        rgba(0, 0, 0, 0) 73.2%
      ),
      linear-gradient(
        359.38deg,
        rgba(0, 0, 0, 0.85) -1.69%,
        rgba(0, 0, 0, 0.42) 18.91%,
        rgba(0, 0, 0, 0.14) 34.61%,
        rgba(0, 0, 0, 0) 49.52%
      );
    mix-blend-mode: multiply;
    transform: rotate(180deg);
  }
  &__call-button {
    padding: 5px 15px;
    height: 32px;
    background: rgba($clementine, 0.7) !important;
  }
  &__connect-button {
    border: none;
    height: 32px;
    background-color: rgba(#f5efeb, 0.7) !important;
    margin: 0 auto;
  }
  &__actions-button {
    background-color: rgba(#f5efeb, 0.7);
    border-radius: 5px;
    height: 32px;
    width: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  &__actions-button-box {
    background-color: white;
    border-radius: 5px;
    position: absolute;
    right: 0;
    top: 2.5rem;
    padding: 0.5rem;
  }
  &__controls {
    margin-top: 1rem;
    height: 50px;
    display: none;
    align-items: center;
    justify-content: flex-start;

    @media (min-width: $breakpoint-1) {
      display: flex;
    }
  }
  &__action__wrapper {
    // Wrapper wraps the icon and the label, as they can be nested into additional components.
    font-size: 0.875rem;
    padding: 0px 8px;
    font-family: $font-family-sans-serif-light;
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.1;
    min-width: 100px;
    white-space: nowrap;
    cursor: pointer;
    @media (max-width: $breakpoint-1) {
      flex-direction: row;
      padding: 12px 10px;
    }
    & > * {
      margin-right: 0.5rem;
    }
  }
}
.action-icon {
  width: 24px;
  margin: 0;
  margin-bottom: 2px;
  @media (min-width: 1200px) {
    width: 24px;
  }
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.delayed-fade-enter-active {
  opacity: 0;
  animation-name: fade;
  animation-duration: 0.2s;
  animation-timing-function: ease-in-out;
  animation-delay: 0.2s;
}
$breakpoint-3: 600px;

.video-main {
  width: 100%;
  height: 100%;
  @media (min-width: $breakpoint-1) {
    overflow: hidden;
    position: relative;
    height: calc(100vh - 160px);
  }

  &::v-deep video {
    width: 100% !important;
    height: 100%;
    min-height: 400px;
    object-fit: cover;
    @media screen and (max-width: 953px) and (orientation: landscape) {
      // object-fit: scale-down;
    }
  }
}
</style>
